const user = {
    name: "Pedro Henrique de Miranda Arthur",
	links: [
		{ name: "GitHub", url: "https://github.com/pedrohma" },
		{ name: "LinkedIn", url: "https://www.linkedin.com/in/pedrohmarthur" },
	],
};

export default user;
